var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 12C3.08947 12 2.25 11.1605 2.25 10.125C2.25 9.08947 2.46447 8 3.5 8C4.53553 8 6 9.08947 6 10.125C6 11.1605 5.16053 12 4.125 12Z",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 12C18.8395 12 18 11.1605 18 10.125C18 9.08947 19.4645 8 20.5 8C21.5355 8 21.75 9.08947 21.75 10.125C21.75 11.1605 20.9105 12 19.875 12Z",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 7.5C14.3395 7.5 13.5 6.66053 13.5 5.625C13.5 4.58947 14.9645 2.5 16 2.5C17.0355 2.5 17.25 4.58947 17.25 5.625C17.25 6.66053 16.4105 7.5 15.375 7.5Z",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 7.5C7.58947 7.5 6.75 6.66053 6.75 5.625C6.75 4.58947 6.96447 2.5 8 2.5C9.03553 2.5 10.5 4.58947 10.5 5.625C10.5 6.66053 9.66053 7.5 8.625 7.5Z",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82162 14.6113C7.7623 14.0888 8.45863 13.216 8.75915 12.1828L8.75923 12.1829C8.9632 11.4812 9.38941 10.8646 9.97381 10.4259C10.5582 9.98718 11.2692 9.75 12 9.75C12.7307 9.75 13.4417 9.98718 14.0261 10.4259C14.6105 10.8646 15.0367 11.4812 15.2407 12.1829L15.2408 12.1828C15.5413 13.216 16.2376 14.0888 17.1783 14.6113C17.8559 14.9786 18.3662 15.5925 18.6034 16.3259C18.8406 17.0593 18.7865 17.8558 18.4523 18.5503C18.1181 19.2449 17.5295 19.7842 16.8084 20.0565C16.0874 20.3288 15.2892 20.3132 14.5793 20.0129C12.9265 19.3352 11.0734 19.3352 9.42062 20.0129C8.7107 20.3135 7.91231 20.3294 7.19103 20.0571C6.46975 19.7849 5.88093 19.2455 5.54667 18.5508C5.21241 17.8561 5.15837 17.0594 5.39575 16.3259C5.63312 15.5924 6.14371 14.9784 6.82162 14.6113Z",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciesIcon);
export default __webpack_public_path__ + "static/media/speciesIcon.d70b2abaa8fe3d51c5af54c7b7ba32b1.svg";
export { ForwardRef as ReactComponent };